/*
  This checks if area is being actually stacked (different from being stackable) due to
  some strategies:
  - Single series on an axis should not stack
  - Band areas should not stack.

*/

import type { AreaMetadata } from '../../../types/xy-chart-internals.js';

export function isAreaSeriesStacked(
  axisId: string,
  combinedAxesOrientationKeyToSeriesCount: Map<string, number>,
  variant: AreaMetadata['variant'],
) {
  const axisSeriesCount =
    combinedAxesOrientationKeyToSeriesCount.get(axisId) ?? 0;
  const isMultipleSeriesOnSameAxis = axisSeriesCount > 1;
  return isMultipleSeriesOnSameAxis && variant !== 'band';
}
